import React, { FC } from 'react'
import Box from '@components/Box'
import ArrowUp from '@icons/ArrowUp.inline.svg'
import { formatMoney } from '@components/InputSlider/helpers'
import { IContributionsProps, ISResultItemProps } from '@components/CalcAero/types'
import { SResultItemTitle, SResultItemContainer, SResultItemValue, SResultItemsContainer, STitle } from './styled'

const SResultItem: FC<ISResultItemProps> = ({ title, value }) => {
  return (
    <SResultItemContainer>
      <SResultItemTitle>{title}</SResultItemTitle>
      <SResultItemValue>{formatMoney(value)}</SResultItemValue>
    </SResultItemContainer>
  )
}

const Contributions: FC<IContributionsProps> = ({ title, resultsData }) => {
  return (
    <>
      <Box display="flex" mb={{ _: '16px', md: '12px' }}>
        <STitle>{title}</STitle>
        <Box m={{ _: '4px 38px 0 22px', md: '4px 0 0 10px' }} width={{ _: '16px' }} height={{ _: '16px' }}>
          <ArrowUp />
        </Box>
      </Box>
      <SResultItemsContainer>
        {resultsData.map(({ title, value }, index) => (
          <SResultItem key={index} title={title} value={value} />
        ))}
      </SResultItemsContainer>
    </>
  )
}

export default Contributions
